// @flow

import React, {useMemo} from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';

import {Table} from '../table.component';
import {DataTableHeaderContext} from '../contexts/data-table-header-context';
import styles from './data-table-headers.module.styl';

import type {ComponentType, Element, ElementConfig, Node} from 'react';


const classNames = withCssModule(styles);

type NativeProps = $Diff<ElementConfig<'div'>, {children: any}>;

export type HeadersProps = NativeProps & {
    children: Element<typeof Table>,
    containerEventListenersType?: string,
    disabledScroll?: boolean,
    hasPinnedRows?: boolean,
    headerRef?: {current: HTMLElement | null},
    headersContainer?: {current: HTMLElement | null},
    getHeaderTopOffset?: () => number,
    isSticky?: boolean,
    modal?: boolean,
    stickyReferenceElement?: HTMLElement | null,
    stickyScroll?: boolean,
    wrapperElement?: HTMLElement | null,
};

export const Headers: ComponentType<HeadersProps> = (props: HeadersProps): Node => {
    const {
        children,
        className,
        disabledScroll,
        headerRef,
        headersContainer,
        isSticky,
        style,
    } = props;

    const containerClasses = classNames('data-table__headers-container', className);

    const contextValue = useMemo(() => ({
        isSticky
    }), [isSticky]);

    const headerClasses = classNames('data-table__headers', {
        'data-table__headers_freeze': isSticky,
        'data-table__headers_no-scroll': disabledScroll,
    });

    return (
        <DataTableHeaderContext.Provider value={contextValue}>
            <div ref={headersContainer} className={containerClasses}/>
            <div
                ref={headerRef}
                style={{...style}}
                className={headerClasses}>
                {children}
            </div>
        </DataTableHeaderContext.Provider>
    );
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../table.component");
